import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faSearch, faTimes } from '@fortawesome/pro-light-svg-icons';
import './SearchInput.scss';

const SearchInput = ({
  value,
  onChange,
  placeholder,
  isLoading,
  inputRef,
  className,
  size,
  showSearchIcon,
  disabled,
  onFocus,
  onBlur,
  autoFocus,
  onClear
}) => {
  return (
    <div
      className={cn('search-input-container', className, {
        loading: isLoading,
        disabled,
        'has-value': value,
        [`size-${size}`]: !!size
      })}
    >
      {showSearchIcon && !isLoading && <FontAwesomeIcon icon={faSearch} className='search-icon' />}
      <input
        className='search-input'
        type='text'
        placeholder={placeholder}
        value={value}
        ref={inputRef}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      {value && onClear && (
        <button className='clear-button' onClick={onClear} type='button' aria-label='Clear search'>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
      {isLoading && <FontAwesomeIcon icon={faSpinner} spin className='search-spinner' />}
    </div>
  );
};

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  isLoading: PropTypes.bool,
  inputRef: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['lg']),
  showSearchIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  autoFocus: PropTypes.bool,
  onClear: PropTypes.func
};

SearchInput.defaultProps = {
  placeholder: 'Search...',
  isLoading: false,
  showSearchIcon: false,
  disabled: false,
  autoFocus: false
};

export default SearchInput;
